import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { ClientScreen, ClientService } from '~app-client/core/services';

@Injectable({ providedIn: 'root' })
export class HomeService {
	private hiddenIdsSet = new Set<string>();

	private bottomNavigationHiddenIds$$ = new BehaviorSubject<string[]>([]);
	public bottomNavigationVisible$ = inject(ClientService).screen$.pipe(
		switchMap((screen) => {
			if (screen === ClientScreen.DESKTOP) {
				return of(false);
			}

			return this.bottomNavigationHiddenIds$$.asObservable().pipe(
				map((ids) => {
					return ids.length === 0;
				})
			);
		})
	);

	private searchResultsLength$$ = new BehaviorSubject(0);

	public searchResultsLength$ = this.searchResultsLength$$.asObservable();

	private scrollToTop$$ = new Subject<void>();
	public scrollToTop$ = this.scrollToTop$$.asObservable();

	private readonly sidenavOpened$$ = new BehaviorSubject(false);
	public readonly sidenavOpened$ = this.sidenavOpened$$.asObservable();

	private readonly sidenavHiddenKeys$$ = new BehaviorSubject<string[]>([]);
	public readonly sidenavVisible$ = this.sidenavHiddenKeys$$.asObservable().pipe(
		map((keys) => {
			return keys.length === 0;
		})
	);

	public emitScrollTop(): void {
		this.scrollToTop$$.next();
	}

	public showBottomNavigation(id: string): void {
		this.hiddenIdsSet.delete(id);
		this.bottomNavigationHiddenIds$$.next([...this.hiddenIdsSet]);
	}

	public hideBottomNavigation(id: string): void {
		this.hiddenIdsSet.add(id);
		this.bottomNavigationHiddenIds$$.next([...this.hiddenIdsSet]);
	}

	public setSearchResultsLength(length: number): void {
		this.searchResultsLength$$.next(length);
	}

	public setSidenavOpened(opened: boolean): void {
		this.sidenavOpened$$.next(opened);
	}

	public addSidenavHiddenKey(key: string): void {
		const arr = [...new Set([...this.sidenavHiddenKeys$$.value, key])];
		this.sidenavHiddenKeys$$.next(arr);
	}

	public removeSidenavHiddenKey(key: string): void {
		this.sidenavHiddenKeys$$.next(
			this.sidenavHiddenKeys$$.value.filter((k) => {
				return k !== key;
			})
		);
	}
}
